import apiClient from './api';
import { AccessAuditSummaryResponse } from '@app-types/tap-partner-vault';

const AUDIT_ENDPOINT = '/api/audit';

export const auditService = {
  async getAccessSummary(): Promise<AccessAuditSummaryResponse> {
    const response = await apiClient.get<AccessAuditSummaryResponse>(`${AUDIT_ENDPOINT}/access-summary`);
    return response.data;
  },
};
